import { lensspecificationconstants } from '../lensspecificationconstants';
import { post } from './http';
import { SUBSCRIPTION_INTERVAL_MONTHLY, VARIANT_90_PACKAGE } from '../constants';

export const add = async ({
  articleNumber,
  quantity = 1,
  rightStrength,
  leftStrength,  
  rightCurve,
  leftCurve,  
  rightDiameter,
  leftDiameter,  
  rightCylinder,
  leftCylinder,  
  rightAxis,
  leftAxis,
  rightEyeAdd,
  leftEyeAdd,
  rightColor,
  leftColor,
  rightPacket,
  leftPacket,
  rightEyeProductNumber,
  leftEyeProductNumber,
  subscription,
  lensDurationCategory,
  clinicalPartActive,
  serveITRecommendationIdentifier,
  serveITSubscriptionIdentifier
}) => {
  if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
    throw 'Invalid quantity';
  }
  
  await post('/api/cart/add', {
    articleNumber: articleNumber,
    quantity: parseFloat(quantity),
    rightStrength: rightStrength,
    leftStrength: leftStrength,
    rightCurve: rightCurve,
    leftCurve: leftCurve,
    rightDiameter: rightDiameter,
    leftDiameter: leftDiameter,
    rightCylinder: rightCylinder,
    leftCylinder: leftCylinder,
    rightAxis: rightAxis,
    leftAxis: leftAxis,
    rightAdd: rightEyeAdd,
    leftAdd: leftEyeAdd,
    rightColor: rightColor,
    leftColor: leftColor,
    rightPacket: rightPacket,
    leftPacket: leftPacket,
    rightEyeProductNumber: rightEyeProductNumber,
    leftEyeProductNumber: leftEyeProductNumber,
    subscription: subscription,
    lensDurationCategory: lensDurationCategory,
    clinicalPartActive: clinicalPartActive,
    serveITRecommendationIdentifier: serveITRecommendationIdentifier,
    serveITSubscriptionIdentifier: serveITSubscriptionIdentifier,
  })
  .then((response) => {    
    return response.json();
  })
  .catch((ex) => {    
    throw ex;      
  });  
};

export const reorder = async (orderId) => {
  const response = await post('/api/cart/reorder', { orderId });
  return response.json();
};

export const GetPacketSizeToAdd = (lensdurationCategory, packageSize) => {
  return lensdurationCategory === SUBSCRIPTION_INTERVAL_MONTHLY ? 1 : (packageSize === VARIANT_90_PACKAGE ? 1 : 3)
}